interface Program {
  id?: string;
  slug?: string;
  name?: string;
  [key: string]: unknown;
}

const slugify = (value: unknown): string =>
  String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)+/g, '')

export const programKey = (program: Program | null | undefined): string | null => {
  if (!program) return null
  if (program.id) return program.id
  if (program.slug) return program.slug
  const slug = slugify(program.name)
  return slug || null
}

export const enhanceProgram = (program: Program): Program & { key: string | null } => ({
  ...program,
  key: programKey(program),
})

export const formatCurrency = (value: unknown): string => {
  if (value === null || value === undefined || value === '') return '—'
  const numberValue = Number(value)
  if (!Number.isFinite(numberValue)) return String(value)
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(numberValue)
}

export default {
  programKey,
  enhanceProgram,
  formatCurrency,
}
